import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Youtube, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1e3a5f] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_beeb63f4-f271-4462-96ad-3cfca96ff85b/artifacts/c5rpsa8q_division%20immobiliere.jpeg" 
              alt="G Division" 
              className="h-16 w-auto mb-6 bg-white p-2"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Experts en division immobilière et accompagnement des biens en indivision. 
              Nous transformons vos projets complexes en opportunités.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold mb-6 text-[#c9a227]">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/qui-sommes-nous" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/nos-projets" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  Nos Projets
                </Link>
              </li>
              <li>
                <Link to="/nos-outils" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  Nos Outils
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold mb-6 text-[#c9a227]">
              Services
            </h4>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">Division Immobilière</li>
              <li className="text-gray-300 text-sm">Sortie d'Indivision</li>
              <li className="text-gray-300 text-sm">Conseil Copropriété</li>
              <li className="text-gray-300 text-sm">Accompagnement Marchand de Biens</li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Playfair_Display'] text-lg font-semibold mb-6 text-[#c9a227]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#c9a227] mt-0.5 flex-shrink-0" />
                <a href="mailto:gdivision.sas@gmail.com" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  gdivision.sas@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#c9a227] mt-0.5 flex-shrink-0" />
                <a href="tel:+33645040975" className="text-gray-300 hover:text-[#c9a227] transition-colors text-sm">
                  +33 6 45 04 09 75
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#c9a227] mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">France</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6">
              <a 
                href="https://www.youtube.com/@G10visions" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#162a45] rounded-full flex items-center justify-center hover:bg-[#c9a227] transition-colors"
                data-testid="youtube-link"
              >
                <Youtube size={18} />
              </a>
              <a 
                href="https://www.linkedin.com/company/111674288" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#162a45] rounded-full flex items-center justify-center hover:bg-[#c9a227] transition-colors"
                data-testid="linkedin-link"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2a4a6f] mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} G Division. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/admin/login" className="text-gray-400 hover:text-[#c9a227] text-sm transition-colors">
              Admin
            </Link>
            <span className="text-gray-400 text-sm">Mentions légales</span>
            <span className="text-gray-400 text-sm">Politique de confidentialité</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
